import { AppConfigKey_FE, dispatch_onAppConfigsUpdated } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { ConfigKey_AdvisorHomePanel, ConfigKey_FAQ_ParentOrder, ConfigKey_FindingView_Cockpit, ConfigKey_FindingView_ParentOrder, ConfigKey_IndependentScores } from '@app/advisor-ui-shared';
import { ConfigKey_SmartDocs_NoteIds } from '@app/advisor-content-shared/_entity/smart-doc/index';
import { DBDef_AppConfig } from '@nu-art/thunderstorm-shared';
// ##################### App Config #####################
class ModuleFE_Advisor_AppConfig_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_AppConfig, dispatch_onAppConfigsUpdated);
    }
    get(appConfigKey) {
        const config = this.cache.find(item => item.key === appConfigKey.key);
        return config?.data;
    }
}
export const ModuleFE_Advisor_AppConfig = new ModuleFE_Advisor_AppConfig_Class();
// ##################### Config Key #####################
export class AdvisorConfigKey_FE {
    key;
    constructor(key) {
        this.key = key;
    }
    get = () => ModuleFE_Advisor_AppConfig.get(this);
}
// ##################### Config Keys #####################
export const AdvisorConfigKeyFE_DischargeVarId = new AdvisorConfigKey_FE('dischargeVarId');
export const AdvisorConfigKeyFE_AdmitVarId = new AdvisorConfigKey_FE('admitVarId');
export const AdvisorConfigKeyFE_ComplaintsTagId = new AdvisorConfigKey_FE('complaintsTag');
export const AdvisorConfigKeyFE_SourceExamTagId = new AdvisorConfigKey_FE('sourceExamTag');
export const AdvisorConfigKeyFE_sourceAdministrativeTagId = new AppConfigKey_FE('sourceAdministrativeTagId');
export const AdvisorConfigKeyFE_sourceHistoryTagId = new AppConfigKey_FE('sourceHistoryTagId');
export const AdvisorConfigKeyFE_SourceVitalSignsTag = new AppConfigKey_FE('vitalsSignsTagId');
export const AdvisorConfigKeyFE_SystemTagIds = new AppConfigKey_FE('systemsTagIds');
export const AdvisorConfigKeyFE_FindingView_ParentOrder = new AdvisorConfigKey_FE(ConfigKey_FindingView_ParentOrder);
export const AdvisorConfigKeyFE_Tag_SpecialAttention = new AdvisorConfigKey_FE('tag__special-attention');
export const AdvisorConfigKeyFE_HPIVarID = new AdvisorConfigKey_FE('HPIVarId');
export const AdvisorConfigKeyFE_FAQParentOrder = new AdvisorConfigKey_FE(ConfigKey_FAQ_ParentOrder);
export const AdvisorConfigKeyFE_FindingView_Cockpit = new AdvisorConfigKey_FE(ConfigKey_FindingView_Cockpit);
export const AdvisorConfigKeyFE_IndependentScores = new AdvisorConfigKey_FE(ConfigKey_IndependentScores);
export const AdvisorConfigKeyFE_HomePanel = new AdvisorConfigKey_FE(ConfigKey_AdvisorHomePanel);
export const AdvisorConfigKeyFE_SmartDocs_NoteIds = new AdvisorConfigKey_FE(ConfigKey_SmartDocs_NoteIds);
//# sourceMappingURL=app-config.js.map